module.exports = "//static.hsappstatic.net/signup-ui-lego/static-1.13740/images/illustrations/contact-properties.svg"